import "./DelayedPriceSystemPromptComponent.scss";
import template from "./DelayedPriceSystemPromptComponent.html";
import {IComponentOptions, IOnDestroy} from "angular";
import {ReplaySubject} from "rxjs";

export const DelayedPricePrompt = "tfDelayedPricePrompt";

export function delayedPricePrompt(): IComponentOptions {
    return {
        template,
        controller: DelayedPriceSystemPromptComponentController
    };
}

export class DelayedPriceSystemPromptComponentController implements IOnDestroy {
    private readonly destroy$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor() {

    }

    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
